import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { frequentItems, DEFAULT_FREQUENT } from "@/lib/featureUsage";

export default function FrequentTools({ variant = "top" }: { variant?: "top" | "sidebar" }) {
  const { me } = useAuth();
  const client = useQueryClient();
  const q = useQuery({ queryKey: ["frequent-tools", me?.id], enabled: !!me,
    queryFn: async () => {
      const response = await fetch("/api/v1/usage/frequent", { credentials: "include" });
      if (!response.ok) throw new Error("常用功能暂未同步");
      return response.json() as Promise<{ items: { target: string; visits: number }[] }>;
    }, staleTime: 30_000, refetchInterval: 60_000, retry: 1 });
  useEffect(() => {
    const refresh = () => { void client.invalidateQueries({ queryKey: ["frequent-tools", me?.id] }); };
    window.addEventListener("whaleseek:usage-flushed", refresh);
    return () => window.removeEventListener("whaleseek:usage-flushed", refresh);
  }, [client, me?.id]);
  if (!me) return null;
  const items = frequentItems((q.data?.items ?? []).map(item => item.target), me.preferences);
  return <nav aria-label="常用功能" data-usage-ignore className={variant === "sidebar"
    ? "space-y-1 border-t px-2 py-3 text-xs dark:border-zinc-800"
    : "max-w-screen-2xl w-full mx-auto px-3 sm:px-6 py-2 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs border-b"}>
    <span className="text-zinc-500" title="近30天独立使用3次后自动加入；同一次访问中的连续点击只计一次">常用</span>
    <Link to="/more-tools" className={variant === "sidebar" ? "block rounded px-2 py-1.5 text-zinc-600 hover:bg-zinc-100 hover:text-blue-600 dark:hover:bg-zinc-800" : "text-zinc-600 hover:text-blue-600"}>🧰 全部功能</Link>
    {items.map(item => <Link key={item.to} to={item.to} className={variant === "sidebar" ? "block rounded px-2 py-1.5 text-blue-600 hover:bg-zinc-100 dark:hover:bg-zinc-800" : "text-blue-600 hover:underline"} title={DEFAULT_FREQUENT.includes(item.to) ? "常用入口" : "根据你的使用记录自动加入"}>{item.label}</Link>)}
    {q.error && <span className="text-zinc-400">自动常用暂未同步</span>}
  </nav>;
}
